import { Tabs } from 'antd';
import qs from 'qs';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { Spin } from 'antd';
import BidPackageDetailComponent from '../../components/bid-packages/BidPackageDetailComponent';
import { RootState } from '../../modules';
import { getBidPackageDetailAsync } from '../../modules/bid-packages';
import BidderListContainer from '../bidders/BidderListContainer';
import { downloadFile } from '../../api/constlink';
import { getBidPackageFileAPIPath } from '../../util/utils';
import Title from 'antd/lib/typography/Title';

const { TabPane } = Tabs;

interface BidPackageDetailContainerProps {
  enterpriseId: string;
  projectId: string;
  bidPackageId: string;
}
function BidPackageDetailContainer({
  match,
  history,
}: RouteComponentProps<BidPackageDetailContainerProps>) {
  const { enterpriseId, projectId, bidPackageId } = match.params;
  const { tab } = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });
  const { data, loading, error } = useSelector(
    (state: RootState) => state.bidPackages.bidPackage,
  );
  // const project = useSelector(
  //   (state: RootState) => state.projects.project.data,
  // );
  const dispatch = useDispatch();
  // useEffect(() => {
  //   if (!project) {
  //     dispatch(getProjectDetailAsync.request({ enterpriseId, projectId }));
  //   }
  // }, [enterpriseId, projectId, project, dispatch]);

  useEffect(() => {
    // if (data === null) {
    dispatch(
      getBidPackageDetailAsync.request({
        enterpriseId,
        projectId,
        bidPackageId,
      }),
    );
    // }
  }, [dispatch, enterpriseId, projectId, bidPackageId]);

  const moveToEditPage = (bidPackageId: number) => {
    history.push(`${bidPackageId}/edit`);
  };

  const _downloadFile = async (
    enterpriseId: string,
    projectId: string,
    attachFileId: string,
    fileName: string,
  ) => {
    await downloadFile(
      getBidPackageFileAPIPath(enterpriseId, projectId),
      attachFileId,
      fileName,
    );
  };

  return (
    <>
      {loading && <Spin />}
      {error && <p style={{ textAlign: 'center' }}>에러 발생!</p>}

      {data && (
        <>
          <Title level={3}>{data.name}</Title>
          <Tabs defaultActiveKey={tab as string} destroyInactiveTabPane>
            <TabPane tab="기본정보" key="1">
              <BidPackageDetailComponent
                enterpriseId={enterpriseId}
                projectId={projectId}
                bidPackage={data}
                moveToEditPage={moveToEditPage}
                downloadAttachFile={_downloadFile}
              />
            </TabPane>
            <TabPane tab="참가업체" key="2">
              <BidderListContainer
                enterpriseId={enterpriseId}
                projectId={projectId}
                bidPackageId={bidPackageId}
              />
            </TabPane>
            {/* <TabPane tab="내역서" key="3">
              <BidPackageLineItemListContainer
                enterpriseId={enterpriseId}
                bidPackageId={bidPackageId}
                projectId={projectId}
              />
            </TabPane> */}
          </Tabs>
        </>
      )}
    </>
  );
}

export default BidPackageDetailContainer;
